import React, { useState, useEffect } from "react";
import BackgroundImage from "gatsby-background-image";
import classNames from "classnames";
import MainNav from "./layout/MainNav";
import MainFooter from "./layout/MainFooter";
import * as styles from "./mainLayout.module.scss";

const MainLayout = ({
    className,
    children,
    variant,
    bgImage,
    variantUrl = false,
    bgColor,
    noBottomPadding,
}) => {
    useEffect(() => {
        var eci_count = 15;
        var ecicount20231107 = setInterval(function () {
            if (eci_count >= 0) {
                document.querySelector("#eci_counter span").innerHTML =
                    eci_count--;
            } else {
                clearInterval(ecicount20231107);
                window.location = "https://agital.com/";
            }
        }, 1000);
    }, []);

    return (
        <div className={classNames(styles[variant.toLowerCase()], className)}>
            <MainNav variant={variant.toLowerCase()} />

            <main
                className={classNames(styles.main, {
                    [styles.noBottomPadding]: noBottomPadding,
                })}
                style={{ backgroundColor: bgColor }}
            >
                {bgImage && bgImage.fluid ? (
                    <BackgroundImage
                        className={
                            variantUrl ? styles.variantUrl : styles.bgImage
                        }
                        fluid={bgImage.fluid}
                    >
                        {children}
                    </BackgroundImage>
                ) : (
                    children
                )}
            </main>
            <div className={styles.eci_popup_agital}>
                <div className={styles.eci_overlay}></div>
                <div className={styles.eci_popup_content}>
                    <h2>we've embarked on a new chapter. </h2>
                    <h1>Highnoon is now Agital!</h1>
                    <p>Join the marketing revolution</p>
                    <a href="https://agital.com/?__hstc=267204177.44d054c83d50ac8e8f735ed56b9cca24.1706822627785.1706822627785.1706822627785.1&amp;__hssc=267204177.1.1706822627786&amp;__hsfp=846936583">
                        visit agital
                        <span>
                            <svg
                                id="Layer_1"
                                xmlns="
    http://www.w3.org/2000/svg"
                                viewBox="0 0 14.15 13.74"
                            >
                                <defs></defs>
                                <path
                                    className={styles.cls_1}
                                    d="m9.73,8.09H.65c-.33,0-.65-.27-.65-.6v-1.32c0-.33.32-.6.66-.6l9.06.04-3.87-3.7c-.24-.23-.25-.62,0-.86l.88-.88c.23-.23.61-.23.84,0l6.41,6.31c.24.23.24.62,0,.85l-6.33,6.23c-.24.23-.61.23-.85,0l-.94-.94c-.24-.24-.23-.62.01-.86l3.85-3.67Z"
                                ></path>
                            </svg>
                        </span>
                    </a>
                    <div id="eci_counter" className={styles.eci_counter}>
                        You'll be redirected in <span>15</span>
                    </div>
                </div>
            </div>
            <MainFooter variant={variant.toLowerCase()} />
        </div>
    );
};

MainLayout.defaultProps = {
    variant: "light",
    noBottomPadding: false,
};

export default MainLayout;
